import { Banner } from '@scale/scaleui';
import { useOCPStore } from '../hooks/useOCPStore';

const InfoBanner = () => {
  const { infoBannerData, setInfoBannerData } = useOCPStore(state => ({
    infoBannerData: state.infoBannerData,
    setInfoBannerData: state.setInfoBannerData,
  }));
  return (
    infoBannerData && (
      <div style={{ padding: '10px 12.5%' }}>
        <Banner
          cta={infoBannerData.cta}
          buttonVariant={infoBannerData.buttonVariant}
          onClose={() => setInfoBannerData(null)}
          subtitle={infoBannerData.subtitle}
          title={infoBannerData.title}
          variant={infoBannerData.variant}
        />
      </div>
    )
  );
};

export default InfoBanner;
